module.exports = __webpack_public_path__ + "47348376d1f80425ae03b40b93882853.svg";